import parsePhoneNumberFromString from "libphonenumber-js";

export const validateCaseDescription = (text: string) => {
    if (text.length < 20) {
        return { valid: false, error: "Please enter at least 40 characters" };
    } else if (text.length > 500) {
        return {
            valid: false,
            error: "Please enter no more than 500 characters",
        };
    }
    return { valid: true, error: "" };
};

export const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        return { valid: false, error: "Please enter a valid email address" };
    }
    return { valid: true, error: "" };
};

export const validatePhone = (phone: string) => {
    try {
        const phoneNumber = parsePhoneNumberFromString(phone, 'US')

        if (!phoneNumber || !phoneNumber.isValid()) {
            return {
                valid: false,
                error: "Please enter a valid US phone number"
            }
        }

        return { valid: true, error: "" }
    } catch (error) {
        return {
            valid: false,
            error: "Please enter a valid US phone number"
        }
    }
}

export const validateName = (name: string, fieldName: string) => {
    if (name.trim() === "") {
        return { valid: false, error: `${fieldName} is required` };
    } else if (name.length > 63) {
        return {
            valid: false,
            error: `${fieldName} should not exceed 63 characters`,
        };
    }
    return { valid: true, error: "" };
};


export const calculateAccidentDate = (selection: string): Date => {
    const today = new Date();
    const accidentDate = new Date();

    switch (selection) {
        case "lessthan3monthsCA":
            accidentDate.setDate(today.getDate() - 45);
            break;
        case "lessthan6monthsCA":
            accidentDate.setDate(today.getDate() - 135);
            break;
        case "lessthanyearCA":
            // Within 6 months - set date to 270 days ago
            accidentDate.setDate(today.getDate() - 270);
            break;
        case "within2yearsCA":
            // Within 2 years - set date to 545 days ago
            accidentDate.setDate(today.getDate() - 545);
            break;
        case "moreThan2yearsCA":
            // More than 2 years - set date to exactly 730 days ago (2 years)
            accidentDate.setDate(today.getDate() - 730);
            break;
        case "lessthanyear":
            // Within 6 months - set date to 90 days ago
            accidentDate.setDate(today.getDate() - 90);
            break;
        case "within2years":
            // Within 2 years - set date to 600 days ago
            accidentDate.setDate(today.getDate() - 390);
            break;
        case "moreThan2years":
            // More than 2 years - set date to exactly 730 days ago (2 years)
            accidentDate.setDate(today.getDate() - 730);
            break;
        default:
            break;
    }

    return accidentDate;
};

// Helper function to format date to only include year, month, day (YYYY-MM-DD) without time
export const formatDateWithoutTime = (date: Date | null): string | null => {
    if (!date) return null;

    const year = date.getFullYear();
    // getMonth() returns 0-11, so add 1 for standard month format (1-12)
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};


export const extractNumber = (str?: string): number | null => {
    if (!str) return null;

    // Match one or more digits at the beginning of the string
    const match = str.match(/^\d+/);

    // Return the parsed number or null if no match
    return match ? parseInt(match[0], 10) : null;
};


// Helper function to get current date/time in PST format
export const getPSTDateTime = () => {
    const now = new Date();
    const pstDate = new Date(now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));

    const month = String(pstDate.getMonth() + 1).padStart(2, '0');
    const day = String(pstDate.getDate()).padStart(2, '0');
    const year = pstDate.getFullYear();
    const hours = String(pstDate.getHours()).padStart(2, '0');
    const minutes = String(pstDate.getMinutes()).padStart(2, '0');

    return `${month}/${day}/${year} ${hours}:${minutes}`;
};